<template>
  <v-main>

    <v-container
        id="users-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-bank-transfer-in"
          class="px-5 py-5"
      >


        <shared-page-messages :error-messages="errorMessages"
                              :warning-messages="warningMessages"
                              :success-messages="successMessages">
        </shared-page-messages>

        <v-card-text>
            <v-card-title class="pr-0">
              <v-row>

                <v-col
                    cols="12"
                    sm="12"
                    class="float-right p-0 mb-5"
                >

                  <v-dialog
                      v-model="filtersDialog"
                      max-width="400"
                  >

                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          small
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          class="float-right mr-0"
                      >
                        <v-icon size="small">mdi-filter</v-icon> Filters
                      </v-btn>
                    </template>


                    <form @submit.prevent="applyFilters">

                      <v-card>
                        <v-card-title class="text-h5">
                          Member Filters
                        </v-card-title>

                        <v-card-text>
                          <v-row dense>
                            <v-col
                                cols="12"
                                sm="12"
                            >
                              <v-text-field
                                  v-model="filter.firstName"
                                  label="Member First Name"
                                  dense
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row dense>
                            <v-col
                                cols="12"
                                sm="12"
                            >
                              <v-text-field
                                  v-model="filter.lastName"
                                  label="Member Last Name"
                                  dense
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row dense>
                            <v-col
                                cols="12"
                                sm="12"
                            >
                              <v-select
                                  v-model="filter.claimStatuses"
                                  :items="computedClaimStatusItems"
                                  label="Claim Status"
                                  dense
                                  multiple
                              ></v-select>
                            </v-col>
                          </v-row>

                          <v-row dense>
                            <v-col
                                cols="4"
                                sm="4"
                            >
                              <v-select
                                  v-model="filter.itemsPerPage"
                                  :items="[10, 25, 50, 100]"
                                  label="Items Per Page"
                                  dense
                              >

                              </v-select>
                            </v-col>
                          </v-row>

                        </v-card-text>

                        <v-card-actions class="pt-0">
                          <v-spacer></v-spacer>
                          <v-btn
                              small
                              color="primary"
                              @click="filtersDialog = false"
                              class="mx-1"
                          >
                            Close
                          </v-btn>
                          <v-btn
                              small
                              color="primary"
                              type="submit"
                              class="mx-1"
                          >
                            Apply
                          </v-btn>
                          <v-btn
                              small
                              color="primary"
                              class="mx-1"
                              @click="resetFilters"
                          >
                            Reset
                          </v-btn>
                        </v-card-actions>

                      </v-card>

                    </form>

                  </v-dialog>
                </v-col>
              </v-row>
            </v-card-title>


            <v-simple-table dense
                            :items="claims"
                            :items-per-page="filter.itemsPerPage"
                            class="elevation-1"
                            loading-text="Loading... Please wait"
            >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-subtitle-2 incident-date">Date</th>
                  <th class="text-subtitle-2 dependent-name">Member</th>
                  <th class="text-subtitle-2 member-name">Dependent</th>
                  <th class="text-subtitle-2 relationship-type">Relationship</th>
                  <th class="text-subtitle-2 cause-of-death">Cause</th>
                  <th class="text-subtitle-2 claim-status">Status</th>
                  <th class="text-subtitle-2 claim-action">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                    v-for="claim in claims"
                    :key="claim.id"
                >
                  <td>{{ claim.incidentDate | formatLocalDate }}</td>
                  <td>
                    <router-link :to="{ name: 'view_claim', params: {memberId: claim.user.id, claimId: claim.id} }">
                      {{ claim.user.names }}
                    </router-link>
                  </td>
                  <td>
                    {{ claim.dependent.names }}
                  </td>
                  <td>{{ claim.dependent.relationType.name }}</td>

                  <td>{{ claim.cause }}</td>
                  <td>{{ claimStatusMap[claim.status] }}</td>
                  <td>
                    <router-link :to="{ name: 'edit_claim', params: {memberId: claim.user.id, claimId: claim.id} }">
                      Review
                    </router-link>
                  </td>

                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div class="text-center mt-3">
            <v-pagination
                v-model="filter.page"
                :length="searchResponse.page.totalPages || 1"
                :total-visible="8"
                @input="fetchClaims"
            ></v-pagination>
          </div>

        </v-card-text>


      </base-material-card>


    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import constants from '@/utils/constants'
import SharedPageMessages from '../shared/PageMessages.vue'

export default {
  name: 'CoreClaimsView',
  components: {
    SharedPageMessages
  },

  async created() {
    await this.fetchClaims()
  },

  props: [
    'claimStatuses'
  ],

  computed: {
    claims() {
      return this.searchResponse.content
    },
    computedClaimStatusItems() {
        return Object.keys(this.claimStatusMap)
            .map((key) => ({value: key, text: this.claimStatusMap[key]}))
    }
  },

  methods: {
    clearMessages() {
      this.successMessages = []
      this.errorMessages = []
      this.warningMessages = []
    },
    async applyFilters() {
      this.filtersDialog = false
      this.clearMessages()
      await this.fetchClaims()
    },
    async resetFilters() {
      this.filtersDialog = false
      this.clearMessages()
      this.filter = {
        claimStatuses: [],
        firstName: '',
        lastName: '',
        itemsPerPage: 25,
        page: 1,
      }
      await this.fetchClaims()
    },
    async fetchClaims(page) {
      this.filter.page = page || 1
      let params = {
        firstName: this.filter.firstName,
        lastName: this.filter.lastName,
        statuses: this.filter.claimStatuses.join(','),
        limit: this.filter.itemsPerPage,
        page: this.filter.page,
      }

      return api.searchClaims(params)
          .then(response => {
            this.searchResponse = response.data
          })
          .catch(err => {
            let errorMessage = api.parseResponseError(err)
            this.errorMessages.push(errorMessage)
          })
    }
  },

  data() {
    return {
      errorMessages: [],
      successMessages: [],
      warningMessages: [],
      filtersDialog: false,
      filter: {
        claimStatuses: this.claimStatuses || [],
        page: 1,
        itemsPerPage: 25,
      },
      searchResponse: {
        content: [],
        empty: true,
        page: {
          totalPages: 0,
        }
      },
      claimStatusMap: constants.getClaimStatusMap()
    }
  }
}
</script>

<style lang="sass">
th.claim-status, th.claim-action
  width: 5%

th.dependent-location, th.incident-date
  width: 10%


</style>
